var map = {
	"./AddList.svg": 685,
	"./AutoOff.svg": 686,
	"./Delay.svg": 687,
	"./Facebook.svg": 688,
	"./Gia02_icon.svg": 689,
	"./Instagram.svg": 690,
	"./LINE.svg": 691,
	"./PDF.svg": 692,
	"./Telegram.svg": 693,
	"./Twitter.svg": 694,
	"./V.svg": 695,
	"./WalletAdd.svg": 696,
	"./XBackGreen.svg": 338,
	"./XbackIcont.svg": 697,
	"./XbackIcontWhite.svg": 698,
	"./Youtube.svg": 699,
	"./accountCompany.svg": 700,
	"./accountIcon.svg": 701,
	"./accountWallet.svg": 702,
	"./active-green.svg": 703,
	"./active-white.svg": 704,
	"./add-account.svg": 705,
	"./add-green-pdf.svg": 706,
	"./add-personal.svg": 707,
	"./add.svg": 240,
	"./addFilePDF.svg": 339,
	"./addGray.svg": 241,
	"./addListGray.svg": 708,
	"./adminAdd.svg": 709,
	"./adminSetting.svg": 710,
	"./arrowLeftMobilePreview.svg": 711,
	"./arrowLeftWhite.svg": 340,
	"./arrowRight.svg": 193,
	"./back.svg": 712,
	"./bank-card.svg": 242,
	"./building.svg": 341,
	"./buildingIcon.svg": 243,
	"./burnIcon.svg": 244,
	"./burnIconGray.svg": 342,
	"./camera-green.svg": 343,
	"./checkGreen.svg": 713,
	"./checkRed.svg": 714,
	"./checkedIcon.svg": 715,
	"./chooseSetting.svg": 716,
	"./circleStatus0.svg": 717,
	"./circleStatus1.svg": 718,
	"./circleStatus2.svg": 719,
	"./circleStatus3.svg": 720,
	"./circleStatus4.svg": 721,
	"./circleSuccess.svg": 245,
	"./clearIconActive.svg": 722,
	"./clockIcon.svg": 344,
	"./close-black.svg": 723,
	"./close-red.svg": 724,
	"./close-text-white.svg": 725,
	"./close-white.svg": 194,
	"./closeGreen.svg": 124,
	"./closeIcon.svg": 195,
	"./closeTokenModal.svg": 726,
	"./closeTokenModalW.svg": 727,
	"./company.svg": 728,
	"./completed.svg": 729,
	"./csv.svg": 345,
	"./date-icon-white.svg": 730,
	"./date-icon.svg": 731,
	"./default-img.svg": 732,
	"./delete-white.svg": 733,
	"./delete.svg": 346,
	"./deleteDraftData.svg": 734,
	"./deletePersonal.svg": 735,
	"./deleteSuccess.svg": 736,
	"./document.svg": 737,
	"./documentPay.svg": 347,
	"./documentPayActive.svg": 348,
	"./earthIcon.svg": 196,
	"./earthWifi.svg": 349,
	"./editIcon.svg": 738,
	"./exclamationIcon.svg": 739,
	"./file1.svg": 740,
	"./fileInput.svg": 741,
	"./folder-blue.svg": 246,
	"./folder.svg": 742,
	"./gift.svg": 743,
	"./grayStatus.svg": 744,
	"./greenStatus.svg": 745,
	"./groupMail.svg": 746,
	"./home.svg": 747,
	"./iconAdd.svg": 748,
	"./iconAddDocument.svg": 749,
	"./iconAddList.svg": 750,
	"./iconAddMail.svg": 751,
	"./iconAddNet.svg": 752,
	"./iconAddNote.svg": 753,
	"./iconAddTXT.svg": 754,
	"./iconAddTag.svg": 755,
	"./iconAddToken.svg": 756,
	"./iconAddWallet.svg": 757,
	"./iconArrowRight.svg": 758,
	"./iconBin.svg": 759,
	"./iconBinWhite.svg": 760,
	"./iconBurn.svg": 761,
	"./iconBurnModal.svg": 762,
	"./iconBurnRed.svg": 350,
	"./iconBurnWhite.svg": 763,
	"./iconButtonToken.svg": 764,
	"./iconButtonTokenList.svg": 765,
	"./iconCalendar.svg": 766,
	"./iconCalendarGrey.svg": 767,
	"./iconCamera.svg": 351,
	"./iconCameraGrey.svg": 352,
	"./iconCheck.svg": 768,
	"./iconCheckActive.svg": 353,
	"./iconCheckPay.svg": 354,
	"./iconCheckSuccess.svg": 769,
	"./iconCheckWhite.svg": 770,
	"./iconClock.svg": 771,
	"./iconClockActive.svg": 772,
	"./iconClose.svg": 355,
	"./iconCloseModal.svg": 247,
	"./iconCloseWhite.svg": 773,
	"./iconCloseWhiteDisable.svg": 774,
	"./iconCommunity.svg": 775,
	"./iconCreateLock.svg": 776,
	"./iconCreateLock2.svg": 777,
	"./iconCreateLockDisabled.svg": 778,
	"./iconDanger.svg": 197,
	"./iconDate.svg": 779,
	"./iconDeleteBin.svg": 356,
	"./iconDeleteBinActive.svg": 357,
	"./iconDeleteDisable.svg": 780,
	"./iconDeleteGray.svg": 781,
	"./iconDeleteRed.svg": 782,
	"./iconDeleted.svg": 358,
	"./iconDeletedActive.svg": 359,
	"./iconDocumentEmpty.svg": 783,
	"./iconDown.svg": 125,
	"./iconDownBlack.svg": 248,
	"./iconDownBlue.svg": 784,
	"./iconDownDisabled.svg": 93,
	"./iconDownload.svg": 785,
	"./iconDownloadGray.svg": 786,
	"./iconDownloadGrey.svg": 787,
	"./iconDropdown.svg": 79,
	"./iconEdit.svg": 788,
	"./iconEditAvatar.svg": 789,
	"./iconEditAvatarGreen.svg": 790,
	"./iconEditModal.svg": 791,
	"./iconExit.svg": 792,
	"./iconExportCSV.svg": 793,
	"./iconEyes.svg": 794,
	"./iconFinancial.svg": 795,
	"./iconFix.svg": 796,
	"./iconFly.svg": 797,
	"./iconHeaderWhiteList.svg": 798,
	"./iconI.svg": 799,
	"./iconImgEmp.svg": 800,
	"./iconLanguage.svg": 801,
	"./iconLanguageModal.svg": 360,
	"./iconLeft.svg": 126,
	"./iconList.svg": 802,
	"./iconListToken.svg": 803,
	"./iconListToken1.svg": 804,
	"./iconListToken2.svg": 805,
	"./iconListToken3.svg": 806,
	"./iconListToken4.svg": 807,
	"./iconListToken5.svg": 808,
	"./iconListToken6.svg": 809,
	"./iconListToken7.svg": 810,
	"./iconLock.svg": 811,
	"./iconLock2FA.svg": 812,
	"./iconLockActive.svg": 813,
	"./iconLogout.svg": 814,
	"./iconMail.svg": 815,
	"./iconMedia.svg": 816,
	"./iconNotAllow.svg": 817,
	"./iconNote.svg": 818,
	"./iconNoteDelete.svg": 819,
	"./iconNoteGreen.svg": 820,
	"./iconNoteLink.svg": 821,
	"./iconNoteLock.svg": 822,
	"./iconPDF.svg": 361,
	"./iconPDFModal.svg": 823,
	"./iconPdfButton.svg": 824,
	"./iconPenalty.svg": 825,
	"./iconProcess.svg": 826,
	"./iconRSX.svg": 827,
	"./iconRecycleBin.svg": 828,
	"./iconRight.svg": 829,
	"./iconSearch.svg": 362,
	"./iconSetting.svg": 830,
	"./iconSetting2.svg": 198,
	"./iconSetting3.svg": 831,
	"./iconSettingWhite.svg": 832,
	"./iconShare.svg": 104,
	"./iconSubnet.svg": 833,
	"./iconTXT.svg": 834,
	"./iconTag.svg": 835,
	"./iconTagLink.svg": 836,
	"./iconThreeDot.svg": 837,
	"./iconTime.svg": 363,
	"./iconTimeBlue.svg": 838,
	"./iconTimeSecond.svg": 839,
	"./iconToBin.svg": 840,
	"./iconToBinActive.svg": 841,
	"./iconTop.svg": 162,
	"./iconUser.svg": 842,
	"./iconView.svg": 249,
	"./iconWallet.svg": 199,
	"./iconWarning.svg": 843,
	"./iconWifi.svg": 844,
	"./iconWifiActive.svg": 845,
	"./iconWifiDisabled.svg": 846,
	"./iconWorld.svg": 364,
	"./iconX-White.svg": 847,
	"./iconX.svg": 848,
	"./iconXCircle.svg": 849,
	"./iconZic.svg": 850,
	"./imgTokenTopNews.svg": 851,
	"./info.svg": 852,
	"./inputIcon.svg": 853,
	"./iplus.svg": 854,
	"./kiteGray.svg": 855,
	"./kiteWhite.svg": 365,
	"./listPay.svg": 366,
	"./listPayActive.svg": 367,
	"./loading-black.svg": 368,
	"./loading-green.svg": 856,
	"./loading-white.svg": 857,
	"./lock.svg": 858,
	"./logout-gray.svg": 337,
	"./logout.svg": 369,
	"./logoutGreen.svg": 859,
	"./logoutModal.svg": 860,
	"./mail.svg": 861,
	"./mailGray.svg": 862,
	"./mailInput.svg": 863,
	"./mobileBattery.svg": 370,
	"./mobileSignal.svg": 371,
	"./newDocument.svg": 864,
	"./note.svg": 865,
	"./payConfirm.svg": 372,
	"./payConfirmActive.svg": 373,
	"./paymed.svg": 374,
	"./paymedActive.svg": 375,
	"./payment-app.svg": 866,
	"./payment.svg": 867,
	"./pdf-download.svg": 868,
	"./pen-icon.svg": 869,
	"./person.svg": 870,
	"./personal.svg": 871,
	"./phone.svg": 872,
	"./plus.svg": 873,
	"./point.svg": 874,
	"./pointingRight.svg": 250,
	"./previewMobile.svg": 875,
	"./purpleStatus.svg": 876,
	"./redStatus.svg": 877,
	"./registrationEmail.svg": 878,
	"./save.svg": 879,
	"./saveClipboard.svg": 880,
	"./saveGray.svg": 881,
	"./select.svg": 882,
	"./send.svg": 883,
	"./sendBlue.svg": 884,
	"./sendBlueFail.svg": 376,
	"./sendGray.svg": 377,
	"./sendHome.svg": 378,
	"./setting.svg": 379,
	"./settingAdmin.svg": 885,
	"./settingHeader.svg": 886,
	"./settingModal.svg": 887,
	"./shop.svg": 888,
	"./stop.svg": 380,
	"./submit.svg": 889,
	"./success-red.svg": 890,
	"./successBlack.svg": 891,
	"./successGreen.svg": 381,
	"./symbolLevias.svg": 892,
	"./testMail.svg": 893,
	"./testSMS.svg": 894,
	"./text-white.svg": 895,
	"./textSetting.svg": 896,
	"./token_3.svg": 897,
	"./trash.svg": 898,
	"./twoFactorAuthentication.svg": 382,
	"./user.svg": 383,
	"./v-grey.svg": 384,
	"./violetStatus.svg": 899,
	"./warning.svg": 251,
	"./warningIcon.svg": 900,
	"./wifiIcon.svg": 901,
	"./wifiIconGray.svg": 902,
	"./wifiWarning.svg": 385,
	"./x-card-red.svg": 903,
	"./x-phone-red.svg": 904,
	"./yellowStatus.svg": 386
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1666;